import Navbar from "../Navbar/Navbar";
import Logo from "../../assets/Logo.png";
import "./Header.scss";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header>
      <div className="nav-area">
        <Link to="/" className="logo">
          <img src={Logo} alt=""></img>
        </Link>
        <Navbar />
      </div>
    </header>
  );
};

export default Header;
